import React from 'react';
import Menu from './Menu'
import Center from './Center';





function Content (props){
    return(
        <div className='container-fluid content'>
            
        <Menu  state={props.state} setState={props.setState}/>
        <Center sid={props.sid} />
       
       






        </div>





    );

}



export default Content